import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { CATEGORY_CONSTANTS } from "../../../../../constants/index.js";
import { MenuActionCreators } from "../../../../../redux/action-creators/index.js";
import { MenuSelectors } from "../../../../../redux/selectors/index.js";

export const useSpectateNumberOfItemsMobile = () => {
  const dispatch = useDispatch();
  const numberOfDisplayedItems = useSelector(
    MenuSelectors.numberOfDisplayedItems
  );

  useEffect(() => {
    dispatch(
      MenuActionCreators.setNumberOfDisplayedItems(
        CATEGORY_CONSTANTS.SPECTATE_NUMBER_OF_CATEGORIES
      )
    );
  }, [dispatch]);

  return numberOfDisplayedItems;
};
